import { groupByActionTypes } from "redux-undo";
import { v4 as uuid } from "uuid";

export const batchGroupBy = {
  _group: null,
  start(group = uuid()) {
    this._group = group;
  },
  end() {
    this._group = null;
  },
  init(rawActions) {
    const defaultGroupBy = groupByActionTypes(rawActions);
    return (action) => this._group || defaultGroupBy(action);
  },
};
